import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, ArrowRight, LogIn } from "lucide-react";
import { Button } from "./ui/button";
import { CONTACT } from "../data/mock";

export default function CTASection() {
  return (
    <section id="contatti" className="relative py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-[#0a1f55] via-[#102a6b] to-[#1e3a8a] p-10 md:p-16">
          <div className="absolute -top-24 -left-24 h-80 w-80 rounded-full bg-[#f59e0b]/20 blur-3xl"></div>
          <div className="absolute -bottom-24 -right-24 h-80 w-80 rounded-full bg-white/10 blur-3xl"></div>

          <div className="relative grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#f59e0b]">
                Unisciti alla rete ACDT
              </div>
              <h2 className="mt-3 text-3xl md:text-5xl font-extrabold text-white leading-[1.05]">
                Costruisci il tuo futuro nel digitale.
                <br />
                <span className="text-[#fbbf24]">Inizia oggi.</span>
              </h2>
              <p className="mt-5 text-slate-200/90 text-lg max-w-2xl leading-relaxed">
                Iscriviti all'Associazione, ottieni la tessera ufficiale e accedi a percorsi
                formativi, comunità, eventi e strumenti operativi per la libera professione.
              </p>
              <div className="mt-7 flex flex-wrap gap-3">
                <Link to="/area-soci">
                  <Button data-testid="cta-accesso-soci" className="bg-[#1e40af] hover:bg-[#1e3a8a] text-white font-bold h-12 px-6 shadow-lg">
                    <LogIn className="mr-2 h-4 w-4" />
                    Accesso Soci
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </Link>
                <a href={CONTACT.whatsappDirect} target="_blank" rel="noreferrer">
                  <Button variant="outline" className="h-12 bg-white/5 border-white/20 text-white hover:bg-white/10 hover:text-white">
                    <MessageCircle className="mr-2 h-4 w-4 text-[#25D366]" />
                    Sportello del cittadino
                  </Button>
                </a>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm p-7">
                <div className="text-sm text-slate-300">Contatti rapidi</div>
                <div className="mt-3 space-y-3">
                  <a href={`mailto:${CONTACT.email}`} className="block text-white font-semibold hover:text-[#fbbf24] transition-colors">
                    {CONTACT.email}
                  </a>
                  <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="block text-white font-semibold hover:text-[#fbbf24] transition-colors">
                    {CONTACT.phone}
                  </a>
                  <div className="text-slate-300 text-sm">{CONTACT.address}</div>
                </div>
                <div className="mt-5 pt-5 border-t border-white/10">
                  <a href={CONTACT.whatsappChannel} target="_blank" rel="noreferrer"
                     className="flex items-center justify-between rounded-lg bg-[#25D366]/10 hover:bg-[#25D366]/20 border border-[#25D366]/30 px-4 py-3 transition-colors">
                    <span className="flex items-center gap-2 text-white text-sm font-semibold">
                      <MessageCircle className="h-4 w-4 text-[#25D366]" />
                      Unisciti al canale WhatsApp
                    </span>
                    <ArrowRight className="h-4 w-4 text-white" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
